<template>
    <v-row align="center">
        <v-col cols="12" md="2" lg="3" class="text-center">
            <div v-if="grade === null" class="d-flex flex-column align-center">
                <v-skeleton-loader type="text" width="80" class="mb-2"></v-skeleton-loader>
                <v-skeleton-loader type="image" width="80" height="80"></v-skeleton-loader>
            </div>

            <template v-else>
                <p class="subtitle mb-2">
                    Nilai
                </p>

                <div class="display-3">
                    {{ grade }}
                </div>
            </template>
        </v-col>

        <v-col cols="12" md="10" lg="9" class="pa-0 pa-sm-3">
            <v-row dense>
                <template v-if="! dataCards">
                    <v-col
                        v-for="i in 4"
                        :key="i"
                        cols="12"
                        sm="6"
                    >
                        <v-skeleton-loader type="image" height="70"></v-skeleton-loader>
                    </v-col>
                </template>

                <template v-else>
                    <v-col
                        v-for="(data, i) in dataCards"
                        :key="i"
                        cols="12"
                        sm="6"
                    >
                        <v-card>
                            <div class="d-flex justify-space-between align-center">
                                <v-card-title class="font-weight-regular">
                                    <v-icon class="mr-4" :color="data.color">{{ data.icon }}</v-icon>
                                    {{ data.title }}
                                </v-card-title>

                                <div class="pa-4 font-weight-bold">
                                    {{ data.text }}
                                </div>
                            </div>
                        </v-card>
                    </v-col>
                </template>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
import secondToHourMinuteSecond from '@/tools/secondToHourMinuteSecond'

export default {
    props: {
        routeInformation: {
            type: Object,
        }
    },

    data() {
        return {
            grade: null,
            dataCards: null,
        }
    },

    created() {
        this.$api.get(`history/${this.$route.params.history_hash}`, { loader: 'appbar' })
            .then(response => {
                this.grade = response.data.grade

                this.dataCards = [
                    {
                        color: 'green',
                        icon: 'mdi-check',
                        title: 'Jawaban benar',
                        text: `${response.data.correct_answers} / ${response.data.total_questions}`
                    }, {
                        color: 'error',
                        icon: 'mdi-flag',
                        title: 'Jawaban ragu',
                        text: response.data.flagged_answers
                    }, {
                        color: 'blue-grey',
                        icon: 'mdi-help',
                        title: 'Tidak dijawab',
                        text: response.data.unanswered_questions
                    }, {
                        color: 'info',
                        icon: 'mdi-timer',
                        title: 'Waktu',
                        text: secondToHourMinuteSecond(response.data.work_second)
                    }
                ]
                this.$emit('input', response.data)

                this.$store.set('ui/title', response.data.tryout_title)
                this.$tracking.pageViewByTitle(
                    'Nilai: ' + response.data.tryout_title + ' ' + this.$store.get('enrollment/selected@title'),
                    this.routeInformation
                )
            })
    },
}
</script>
